export default "__VITE_ASSET__DOpFsA5C__"